import CardWrap from "./CardWrap.tsx";
const BaseCard: React.FC<any> = ({ itemList, style = {}, useTransparentStyle = false }) => {
  return <CardWrap style={style} itemList={itemList} useTransparentStyle={useTransparentStyle} />;
};

export default BaseCard;
